import { Link } from 'react-router-dom';
import { To } from 'history';

// material-ui
import { Box, ButtonBase } from '@mui/material';
import { SxProps } from '@mui/system';

// project-imports
import Logo from './LogoMain';
import LogoIcon from './LogoIcon';

import useAuth from 'hooks/useAuth';

// import vidyalayaLogo from '../../assets/images/homepage/vid_lms_logo 1 1.svg';
import vidyalayaLogo from '../../assets/images/homepage/vidyalaya_lms_logo.png';

// ==============================|| MAIN LOGO ||============================== //

interface Props {
  reverse?: boolean;
  isIcon?: boolean;
  sx?: SxProps;
  to?: To;
}

const LogoSection = ({ reverse, isIcon, sx, to }: Props) => {
  const { user, organization }: any = useAuth();

  const logo = organization?.logoImage.path;
  let redirectPath: To | undefined;

  if (user) {
    if (user?.type === 'student') {
      redirectPath = '/';
    } else if (user?.type === 'faculty') {
      redirectPath = '/faculty';
    } else {
      redirectPath = '/dashboard';
    }
  }

  let logoElement;
  if (user?.type === 'student' || !user) {
    const orgLogoSrc = organization?.logoImage?.[0]?.path;

    logoElement = (
      <Box
        sx={{
          display: 'flex',
          alignItems: 'center',
          gap: orgLogoSrc ? '8px' : 0
        }}
      >
        <img
          src={vidyalayaLogo}
          alt="Vidyalaya"
          width="100"
          height="40"
          style={{
            objectFit: 'contain',
            minHeight: '40px',
            maxHeight: '48px',
            minWidth: '130px',
            filter: 'brightness(0) invert(1)'
          }}
        />

        {orgLogoSrc && (
          <>
            <Box
              sx={{
                width: '1px',
                height: '32px',
                backgroundColor: 'divider',
                opacity: 0.6
              }}
            />

            <img
              src={orgLogoSrc}
              alt={organization?.name || 'Institution'}
              width="90"
              height="50"
              style={{ objectFit: 'contain', minHeight: '40px', maxHeight: '48px', minWidth: '130px', filter: 'brightness(0) invert(1)' }}
            />
          </>
        )}
      </Box>
    );
  } else if (isIcon) {
    logoElement = <LogoIcon />;
  } else {
    logoElement = <Logo reverse={reverse} />;
  }

  return (
    <Box sx={{ display: 'flex' }} className="sidebar-icon">
      <ButtonBase
        disableRipple
        component={Link}
        {...(user && {
          to: to || redirectPath
        })}
        sx={sx}
      >
        {logoElement}
      </ButtonBase>
    </Box>
  );
};

export default LogoSection;
